export const SIZE_TYPE_150 = "150";
export const SIZE_TYPE_150_V3 = "150_V3";
export const SIZE_TYPE_150_V3_BLANK = "150_V3_BLANK";
export const SIZE_TYPE_150_HANJIN = "150_HANJIN";